import * as React from 'react';
import { IgcCircularGradientComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Used for defining gradient stops in the igc-circular-progress.
 * For each `igc-circular-gradient` defined as `gradient` slot of `igc-circular-progress` element would be created a SVG stop element.
 * The values passed as `color`, `offset` and `opacity` would be set as
 * `stop-color`, `offset` and `stop-opacity` of the SVG element without further validations.
 * @class
 */
export const IgrCircularGradient = /* @__PURE__ */ createComponent({
  tagName: 'igc-circular-gradient',
  displayName: 'IgrCircularGradient',
  elementClass: Component,
  react: React,
});

export type IgrCircularGradient = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCircularGradientModule = Component;
